import React, { useState, useEffect, useRef } from "react";
import "./signin.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MessageLabel from "../CommonComponents/MessageLabel";
import { MdOutlineMailOutline } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { toast } from "react-toastify";
import MessageBox from "../CommonComponents/MessageBox";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";

const Forgot = ({ logo }) => {

  const emailRef = useRef(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [resendTimer, setResendTimer] = useState(120);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");

  const [details, setDetails] = useState({
    logo_url: "",
  });

  const [errField, setErrField] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: ""
  });

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    let interval;
    if (step === 2 && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(interval);
  }, [step, resendTimer]);

  useEffect(() => {
    const fetchData = async () => {
      const body = {
        Login_user_type: 9,
        Login_user_id: null,
        Login_device_type: "web"
      };

      try {
        const reqData = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Header-index`, body, {
          headers: {
            'guestverfiykey': "WebVodWebnexs",
            'Content-Type': 'application/json'
          }
        });
        setDetails(reqData?.data?.admin_theme_mode_details);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const toggleConfirmPassword = () => {
    setConfirmPasswordType(confirmPasswordType === "password" ? "text" : "password");
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleEmailChange = (e) => {
    const val = e.target.value;
    setEmail(val);
    if (!val) {
      setErrField(prev => ({ ...prev, email: "Please Enter Email*" }));
    } else if (!validateEmail(val)) {
      setErrField(prev => ({ ...prev, email: "Please Enter Valid Email ID" }));
    } else {
      setErrField(prev => ({ ...prev, email: "" }));
    }
  };

  const handleSendOtp = async () => {
    if (!email || !validateEmail(email)) return;


    setLoading(true);
    try {
      const payload = {
        email: email,
        org_id: process.env.REACT_APP_Baseurl_ORG_ID || "e4e1hzm8fkz3pa",
        deployment_id: process.env.REACT_APP_Baseurl_DEPLOYMENT_ID
      };

      const res = await axios.post(
        `${process.env.REACT_APP_Base_Webnexs_URL}/userapi/auth/send-otp`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (res?.data?.status) {
        toast.success("OTP sent successfully!");
        setStep(2);
        setResendTimer(120);
        setIsResendDisabled(true);
      } else {
        toast.error(res?.data?.message || "Failed to send OTP.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setResendTimer(120);
    setIsResendDisabled(true);
    await handleSendOtp();
  };

  const handleVerifyOtp = async () => {
    setErrField({ ...errField, otp: "" });


    if (!otp) {
      setErrField({ ...errField, otp: "Please Enter OTP*" });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email: email,
        otp: otp,
        org_id: process.env.REACT_APP_Baseurl_ORG_ID || "e4e1hzm8fkz3pa"
      };

      const res = await axios.post(
        `${process.env.REACT_APP_Base_Webnexs_URL}/userapi/auth/verify-otp`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (res?.data?.status) {
        toast.success("OTP verified successfully!");
        setStep(3);
      } else {
        toast.error(res?.data?.message || "Invalid OTP.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const validatePassword = (pwd) => {
    const hasLowerCase = /[a-z]/.test(pwd);
    const hasUpperCase = /[A-Z]/.test(pwd);
    const hasNumber = /\d/.test(pwd);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);

    if (!hasLowerCase || !hasUpperCase || !hasNumber || !hasSpecialChar) {
      return false;
    }
    return true;
  };

  const handlePasswordChange = (e) => {
    const val = e.target.value;
    setPassword(val);
    if (!val) {
      setErrField(prev => ({ ...prev, password: "Password cannot be empty" }));
    } else if (!validatePassword(val)) {
      setErrField(prev => ({ ...prev, password: "Password strength is too weak. (Must contain A-Z, a-z, 0-9, and special char)" }));
    } else {
      setErrField(prev => ({ ...prev, password: "" }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const val = e.target.value;
    setConfirmPassword(val);
    if (!val) {
      setErrField(prev => ({ ...prev, confirmPassword: "Confirm Password cannot be empty" }));
    } else if (val !== password) {
      setErrField(prev => ({ ...prev, confirmPassword: "Passwords do not match" }));
    } else {
      setErrField(prev => ({ ...prev, confirmPassword: "" }));
    }
  };

  const handleResetPassword = async () => {
    if (!password || !confirmPassword || !validatePassword(password) || password !== confirmPassword) return;


    setLoading(true);
    try {
      const payload = {
        email: email,
        password: password
      };

      const res = await axios.post(
        `${process.env.REACT_APP_Baseurl}/users/generate-password`,
        payload,
        {
          headers: {
            'Authorization': 'flicknexs-baseapp',
            'Content-Type': 'application/json'
          }
        }
      );

      if (res?.data?.status) {
        toast.success("Password reset successfully!");
        setTimeout(() => {
          const modal = document.getElementById('exampleModal');
          const closeBtn = document.querySelector('#exampleModal .btn-close');
          if (closeBtn) closeBtn.click();

          // Reset state
          setStep(1);
          setEmail("");
          setOtp("");
          setPassword("");
          setConfirmPassword("");
        }, 2000);
      } else {
        toast.error(res?.data?.message || "Failed to reset password.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (step === 1) handleSendOtp();
      if (step === 2) handleVerifyOtp();
      if (step === 3) handleResetPassword();
    }
  };

  const renderStep1 = () => (
    <>
      <MessageLabel text="Email" className="" />
      <div className="position-relative">
        <MdOutlineMailOutline className="lockIcon position-absolute" />
        <input
          type="email"
          id="forget-email"
          name="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="Enter email"
          ref={emailRef}
          onKeyDown={handleKeyDown}
          className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
        />
        {errField?.email && (<MessageBox text={`${errField?.email}`} classname='errorred mb-2 d-block' />)}
      </div>
      {/* <MessageBox classname="signinLabelText py-3 mb-0 text-center theme-text-color" text="We will send you an OTP to your email." /> */}

      {email && validateEmail(email) && (
        <div className="d-flex my-3 align-items-center justify-content-end">
          <button
            id="forget-submit"
            disabled={loading}
            onClick={handleSendOtp}
            type="button"
            className={`btn button-color button-bg-color admin-button-text text-white rounded-2 py-2 px-3`}
          >
            {loading ? <div className='custom-loading mx-auto'></div> : <MessageBox text={'Send OTP'} />}
          </button>
        </div>
      )}
    </>
  );

  const renderStep2 = () => (
    <>
      <MessageLabel text="Enter OTP" className="" />
      <div className="position-relative">
        <input
          type="text"
          id="forget-otp"
          name="otp"
          value={otp}
          onChange={(e) => {
            const val = e.target.value;
            setOtp(val);
            if (!val) setErrField(prev => ({ ...prev, otp: "Please Enter OTP*" }));
            else setErrField(prev => ({ ...prev, otp: "" }));
          }}
          onKeyDown={handleKeyDown}
          placeholder="Enter OTP"
          className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
        />
        {errField?.otp && (<MessageBox text={`${errField?.otp}`} classname='errorred mb-2 d-block' />)}
      </div>

      {otp && (
        <div className="d-flex my-3 align-items-center justify-content-between">
          <button
            type="button"
            className="btn btn-secondary text-white rounded-2 py-2 px-3"
            onClick={() => setStep(1)}
            disabled={loading}
          >
            Back
          </button>
          <button
            id="verify-otp-submit"
            disabled={loading}
            onClick={handleVerifyOtp}
            type="button"
            className={`btn button-color button-bg-color admin-button-text text-white rounded-2 py-2 px-3`}
          >
            {loading ? <div className='custom-loading mx-auto'></div> : <MessageBox text={'Verify OTP'} />}
          </button>
        </div>
      )}

      <div className="text-center mt-3">
        {isResendDisabled ? (
          <span className="text-muted">Resend OTP in {Math.floor(resendTimer / 60)}:{String(resendTimer % 60).padStart(2, '0')}</span>
        ) : (
          <button
            type="button"
            className="btn btn-link theme-text-color text-decoration-none"
            onClick={handleResendOtp}
          >
            Resend OTP
          </button>
        )}
      </div>
    </>
  );

  const renderStep3 = () => (
    <>
      <MessageLabel text="New Password" className="" />
      <div className="position-relative">
        <input
          type={passwordType}
          name="password"
          value={password}
          onChange={handlePasswordChange}
          onKeyDown={handleKeyDown}
          placeholder="Enter New Password"
          className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
        />
        <button onClick={togglePassword} type="button" className="position-absolute passWordIcon bg-transparent" style={{ top: '10px', right: '10px', border: 'none' }}>
          {passwordType === "password" ? <TbEyeClosed className="eyeClosed theme-text-color" /> : <VscEye className="eyeOpen theme-text-color" />}
        </button>
        <RiLockPasswordLine className="lockIcon position-absolute theme-text-color" />
        {errField?.password && (<MessageBox text={`${errField?.password}`} classname='errorred mb-2 d-block' />)}
      </div>

      <MessageLabel text="Confirm Password" className="" />
      <div className="position-relative">
        <input
          type={confirmPasswordType}
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          onKeyDown={handleKeyDown}
          placeholder="Confirm Password"
          className="rs-input py-3 px-5 form-control-lg custom-placeholder theme-text-color mb-3"
        />
        <button onClick={toggleConfirmPassword} type="button" className="position-absolute passWordIcon bg-transparent" style={{ top: '10px', right: '10px', border: 'none' }}>
          {confirmPasswordType === "password" ? <TbEyeClosed className="eyeClosed theme-text-color" /> : <VscEye className="eyeOpen theme-text-color" />}
        </button>
        <RiLockPasswordLine className="lockIcon position-absolute theme-text-color" />
        {errField?.confirmPassword && (<MessageBox text={`${errField?.confirmPassword}`} classname='errorred mb-2 d-block' />)}
      </div>

      {password && confirmPassword && validatePassword(password) && password === confirmPassword && (
        <div className="d-flex my-3 align-items-center justify-content-end">
          <button
            id="reset-password-submit"
            disabled={loading}
            onClick={handleResetPassword}
            type="button"
            className={`btn button-color button-bg-color admin-button-text text-white rounded-2 py-2 px-3`}
          >
            {loading ? <div className='custom-loading mx-auto'></div> : <MessageBox text={'Reset Password'} />}
          </button>
        </div>
      )}
    </>
  );

  return (
    <div className="adminforgot">
      <div className="modal fade model-x-forgot" id="exampleModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="model-x-button">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  // Reset state on close
                  setStep(1);
                  setEmail("");
                  setOtp("");
                  setPassword("");
                  setConfirmPassword("");
                  setResendTimer(120);
                  setIsResendDisabled(true);
                }}
              ></button>
            </div>
            <div className="modal-body p-4">
              <div className="mt-2 text-center justify-content-center">
                <div className="mt-2 text-center">
                  {details?.light_mode_logo === null ? (<Defaultloadinggif ></Defaultloadinggif>)
                    : (<img src={details?.light_mode_logo} alt="SignInLogo" className="d-block mx-auto  w-50 object-fit-contain" style={{ height: "45px", width: "200px !important" }} />)}
                </div>
                <h4 className="text-center py-2">Forgot Password</h4>
              </div>

              <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                {step === 1 && renderStep1()}
                {step === 2 && renderStep2()}
                {step === 3 && renderStep3()}

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
